<template>
  <div class="impressum-page">
    <header class="impressum-hero">
      <p class="hero-eyebrow">Clearment.ai</p>
      <h1>Impressum</h1>
      <p class="hero-subtitle">
        Dieser Platzhalter dient als Dummy-Inhalt für die Impressums-Seite. Ersetzen Sie die
        Texte bei Bedarf durch die finalen rechtlichen Angaben.
      </p>
    </header>

    <section class="impressum-section">
      <h2>Verantwortlich für den Inhalt</h2>
      <p>
        Clearment GmbH<br />
        Musterstraße 12<br />
        12345 Musterstadt<br />
        Deutschland
      </p>
      <p>
        Telefon: +49 (0) 123 456 789<br />
        E-Mail: hallo@clearment.ai
      </p>
    </section>

    <section class="impressum-section">
      <h2>Vertreten durch</h2>
      <p>Max Mustermann (Geschäftsführer)</p>
    </section>

    <section class="impressum-section">
      <h2>Registereintrag</h2>
      <p>
        Eintragung im Handelsregister.<br />
        Registergericht: Amtsgericht Musterstadt<br />
        Registernummer: HRB 123456
      </p>
    </section>

    <section class="impressum-section">
      <h2>Umsatzsteuer-ID</h2>
      <p>Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz: DE123456789</p>
    </section>

    <section class="impressum-section">
      <h2>Haftungshinweis</h2>
      <p>
        Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte
        externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber
        verantwortlich.
      </p>
    </section>
  </div>
</template>

<script setup>
import { inject } from 'vue'
import { CLEARMENT_TITLE, CLEARMENT_DESCRIPTION } from '@/constants/documentHead'

const updateDocumentHead = inject('updateDocumentHead')
updateDocumentHead?.(CLEARMENT_TITLE, CLEARMENT_DESCRIPTION)
</script>

<style scoped src="@/assets/styles/sfc/components/sites/InfoImpressum.css"></style>
